import React from "react";
import { css } from "glamor";
import { FaWhatsapp } from "react-icons/fa";
import { Mail } from "lucide-react";

const supportPhone = "5511982431592";
const supportPhoneLabel = "(11) 98243-1592";
const supportEmail = "suporte@t2.com.br";
const supportMessagePrefix = "Olá, me chamo";
const supportMessageSuffix = "preciso de ajuda com:";

const sectionTitleClass = css({
  fontFamily: "Montserrat, sans-serif",
  color: "#0F172A",
  fontSize: 16,
  fontWeight: 600,
  lineHeight: "22.5px",
  margin: "10px 0 4px",
});

const helpCardClass = css({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 8,
  overflow: "visible",
  background: "transparent",
  border: "none",
  borderRadius: 0,
  "@media(max-width: 520px)": {
    gridTemplateColumns: "1fr 1fr",
  },
});

const helpItemClass = css({
  display: "flex",
  alignItems: "center",
  gap: 10,
  minWidth: 0,
  minHeight: 54,
  padding: "12px 14px",
  color: "#475569",
  textDecoration: "none",
  overflow: "hidden",
  background: "#FFFFFF",
  border: "0.6px solid #E2E8F0",
  borderRadius: 8,
  "> div": {
    minWidth: 0,
  },
  ":hover": {
    background: "#F8FAFC",
    color: "#0F172A",
  },
});

const whatsappIconClass = css({
  color: "#22C55E",
  flexShrink: 0,
});

const emailIconClass = css({
  color: "#0284C7",
  flexShrink: 0,
});

const helpTitleClass = css({
  color: "#0F172A",
  fontSize: 13,
  fontWeight: 600,
  lineHeight: "18px",
});

const helpSubClass = css({
  color: "#94A3B8",
  fontSize: 11,
  fontWeight: 400,
  lineHeight: "16px",
  marginTop: 2,
  overflowWrap: "anywhere",
});

function supportWhatsappUrl(currentUser) {
  const name = currentUser?.name || [currentUser?.firstName, currentUser?.lastName].filter(Boolean).join(" ");
  const message = name
    ? `${supportMessagePrefix} ${name}, ${supportMessageSuffix}`
    : "Olá, preciso de ajuda com:";

  return `https://api.whatsapp.com/send/?phone=${supportPhone}&text=${encodeURIComponent(message)}`;
}

export default function FinanceHelpSection({ currentUser }) {
  return (
    <>
      <p className={sectionTitleClass}>Preciso de ajuda</p>
      <div className={helpCardClass}>
        <a
          className={helpItemClass}
          href={supportWhatsappUrl(currentUser)}
          target="_blank"
          rel="noreferrer"
        >
          <FaWhatsapp size={18} className={whatsappIconClass} />
          <div>
            <div className={helpTitleClass}>WhatsApp</div>
            <div className={helpSubClass}>{supportPhoneLabel}</div>
          </div>
        </a>
        <a className={helpItemClass} href={`mailto:${supportEmail}`}>
          <Mail size={17} className={`${emailIconClass}`} />
          <div>
            <div className={helpTitleClass}>E-mail</div>
            <div className={helpSubClass}>{supportEmail}</div>
          </div>
        </a>
      </div>
    </>
  );
}
